module.exports = __webpack_public_path__ + "assets/img/count-bg.0a2fb2f0.png";